import React from 'react';
import PropTypes from 'prop-types';
import {
  formatErrors as defaultFormatErrors,
  serializeFormData,
} from './utils';

const Form = ({ initial, children, errors, formatErrors, onSubmit }) => {
  const [fields, setFields] = React.useState(initial);

  const handleChange = (event) => {
    const { target } = event;
    if (!(target.name in fields)) {
      throw new Error(`Unknown form field: ${target.name}`);
    }
    setFields({ ...fields, [target.name]: target.value });
  };

  const handleSubmit = (event) => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    if (onSubmit !== undefined) {
      onSubmit(serializeFormData(fields));
    }
  };

  const formattedErrors = formatErrors
    ? formatErrors(errors)
    : defaultFormatErrors(errors);

  const contents = children({
    change: handleChange,
    data: fields,
    errors: formattedErrors,
    submit: handleSubmit,
    setFields,
  });
  return <form onSubmit={handleSubmit}>{contents}</form>;
};

Form.propTypes = {
  initial: PropTypes.object.isRequired,
  errors: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  onSubmit: PropTypes.func.isRequired,
  formatErrors: PropTypes.func,
};

export default Form;
